import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { Button } from 'ui-components/components/button';
import { noop } from 'ui-components/default-props/noop';

import AddressValidation from '../../components/address-validation';
import { emptyObject } from 'ui-components/default-props/empty';

const NotValidated = (validateAddress, shipToAddress) => {
  return (
    <Button onClick={() => validateAddress(shipToAddress)} theme='link'>
      <FormattedMessage defaultMessage='Validate Address' description='createLabelContent.validateAddress' id='WJf1dm' />
    </Button>
  );
};

const renderValidationStatus = (shipToAddress, validateAddress) => {
  const { verificationStatus } = shipToAddress;
  if (!verificationStatus || verificationStatus === 'UNV') {
    return NotValidated(validateAddress, shipToAddress);
  }

  return (
    <AddressValidation
      countryCode={shipToAddress.countryCode}
      residentialIndicator={shipToAddress.residentialIndicator}
      shipToAddress={shipToAddress}
      validateAddress={validateAddress}
      validation={verificationStatus}
      validationMessage={shipToAddress.verificationMessage}
    />
  );
};

const AddressValidationSection = ({ validateAddress = noop, shipToAddress = emptyObject }) => {
  return <div>{renderValidationStatus(shipToAddress, validateAddress)}</div>;
};

AddressValidationSection.propTypes = {
  validateAddress: PropTypes.func,
  shipToAddress: PropTypes.object,
};

export default AddressValidationSection;
